import axios from 'axios';
import router from '@/router';
import { useToast } from "vue-toastification";
const toast = {
  success(msg, options = {}) {
    return useToast().success(msg, { position: "top-center", ...options });
  },
  error(msg, options = {}) {
    return useToast().error(msg, { position: "top-center", ...options });
  }
};

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVICE_URL,
    withCredentials: true,
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        } else {
            delete config.headers["Authorization"];
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
        if (error) {
            promise.reject(error);
        } else {
            promise.resolve(token);
        }
    });

    failedQueue = [];
};

instance.interceptors.response.use(
    (response) => response,

    async (error) => {
        const status = error.response?.status;
        const originalRequest = error.config;

        if (
            status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url?.includes("account/v1/refresh-token")
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers.Authorization =
                            `Bearer ${token}`;

                        return instance(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const refreshToken =
                    localStorage.getItem("refreshToken");

                const response = await axios.post(
                    `${process.env.VUE_APP_API_SERVICE_URL}account/v1/refresh-token`,
                    {
                        "refreshToken": refreshToken
                    }
                );

                if (response.data.status != '200') {
                    throw new Error("Refresh token failed");
                }

                const newToken =
                    response.data.result.token;

                const newRefreshToken =
                    response.data.result.refreshToken;

                localStorage.setItem("token", newToken);
                localStorage.setItem("refreshToken", newRefreshToken);

                instance.defaults.headers.common.Authorization = `Bearer ${newToken}`;

                processQueue(null, newToken);

                originalRequest.headers.Authorization = `Bearer ${newToken}`;

                return instance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError, null);
                
                // Xử lý khi hết hạn session
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("current-account");
                toast.error("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.");
                router.push("/login");

                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        if (status === 403) {
            if (!originalRequest?._skip403Redirect) {
                router.push({ name: "Forbidden" });
            }
        }

        if (status === 500) {
            toast.error("Có lỗi xảy ra, vui lòng kiểm tra lại kết nối hoặc liên hệ quản trị viên.");
        }
        if (status === 429) {
            toast.error("Quá nhiều yêu cầu được gửi đi, vui lòng chờ trong giây lát.");
        }
        return Promise.reject(error);
    }
);

export default instance;
